import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            本周必看推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            编辑团队精选优质内容，每周更新不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 cursor-pointer transition-all duration-200"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => { const t = e.currentTarget; const p = t.parentElement; if (p) p.style.display = 'none'; }}
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-1 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}